import moment from 'moment'

export const formatTimestamp = (timestamp, type) => {
  if (!type) {
    return moment.unix(timestamp / 1000).format('MMM D h:mma')
  }

  if (type === 'date') {
    return moment.unix(timestamp / 1000).format('MMM D')
  }

  if (type === 'time') {
    return moment.unix(timestamp / 1000).format('h:mma')
  }
}
